export const TabList = [
	{
		id: "general",
		title: "General Information",
	},
	{
		id: "financial",
		title: "Financial Information",
	},
	{
		id: "transactions",
		title: "Transaction History",
	},
	{
		id: "investments",
		title: "Investments",
	},
];



export const customerHeaderCells = [
    { field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "email", title: "EMAIL", width: 150 },
	{ field: "firstName", title: "FIRST NAME", width: 150 },
	{ field: "lastName", title: "LAST NAME", width: 150 },
	{ field: "phone", title: "PHONE NUMBER", sortable: false, width: 100 },
	{ field: "activeProfiles", title: "ACTIVE PROFILE", sortable: false, width: 120 },
	{ field: "profileStatus", title: "PROFILE STATUS", sortable: false, width: 150 },
	{ field: "typeCustomer", title: "ACTION", sortable: false, width: 60 },
]

export const TransactionsCells = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "image", title: "PRODUCT IMAGE", width: 200 },
	// { field: "secondImage", title: "SECOND IMAGE", width: 200 },
	{ field: "productName", title: "PRODUCT NAME", width: 150 },
	{ field: "amount", title: "ASSET VALUE",  width: 160 },
	// { field: "shelfLife", title: "SHELF LIFE", sortable: false, width: 70 },
	{ field: "condition", title: "CONDITION", sortable: false, width: 70 },
	{ field: "state", title: "STATUS", sortable: false, width: 100},
	{ field: "paymentStatus", title: "PAYMENT STATUS", sortable: false, width: 70},
	{ field: "typeTransactions", title: "ACTION", sortable: false, width: 60 },
]

export const UpcomingPaymentCells = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "transactionId", title: "TRANSACTION ID", width: 150 },
	{ field: "assetName", title: "ASSET NAME", width: 150 },
	{ field: "interest", title: "INTEREST",  width: 70 },
	{ field: "value", title: "VALUE", sortable: false, width: 100 },
	{ field: "deposit", title: "DEPOSIT", sortable: false, width: 100},
	{ field: "balance", title: "BALANCE", sortable: false, width: 70},
	{ field: "paymentStatus", title: "PAYMENT STATUS", sortable: false, width: 70},
]

export const InvestmentCells= [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "investmentType", title: "INVESTMENT TYPE", width: 150 },
	{ field: "transactionId", title: "TRANSACTION ID", width: 100 },
	{ field: "principal", title: "PRINCIPAL",  width: 100 },
	{ field: "interest", title: "INTEREST",  width: 100 },
	{ field: "tenure", title: "TENURE", sortable: false, width: 100},
	{ field: "status", title: "STATUS", sortable: false, width: 100},
	{ field: "typeInvesment", title: "ACTION", sortable: false, width: 80 },
]


export const DemoData = [
    {
		id: 1,
        email: "oladapo2gmail.com",
		// createdAt: "",
		firstName: "TIMILEHIN",
		lastName: "OLADAPO",
		phone: "08011111111",
		activeProfile: ['Personal', 'Business', 'Investor'],
		profileStatus: "Flagged",
	},

    {
		id: 2,
        email: "oladapo3gmail.com",
		// createdAt: "",
		firstName: "TIMILEHIN",
		lastName: "OLADAPO",
		phone: "080222222222",
		activeProfile: ['Personal', 'Business', ],
		profileStatus: "Inactive",
	},
]


export const financialInfo = [
	{
	id: 1,
	name: "BVN"
    },
]

export const singleTransactionData = [
	{
		id:1,
		name:"amount",
		type: "text",
	},
	{
		id:2,
		name:"approvalStatus",
		type: "text",
	},
]